module.exports = __webpack_public_path__ + "img/dy.4f7efd05.png";